const dashboard = {
  DASHBOARD: 'DASHBOARD',
  DASHBOARDRECENT: 'DASHBOARDRECENT',
  DASHBOARDTASKSTATUS: 'DASHBOARDTASKSTATUS',
  DASHBOARDJOBSTATUS: 'DASHBOARDJOBSTATUS',

  // ----------ADMIN DASHBOARD ----------------//
  DASHBOARDJOBCARDTASKSTATUS: 'DASHBOARDJOBCARDTASKSTATUS',
  ADMINTASKOVERVIEW: 'ADMINTASKOVERVIEW',
  ADMINBREAKDOWN: 'ADMINBREAKDOWN',
  ADMINALLCOUNT: 'ADMINALLCOUNT',
  ADMINDASHBOARDRECENT: 'ADMINDASHBOARDRECENT',
  ADMINMACHINETIME: 'ADMINMACHINETIME',
  MACHINE_SINGLE: 'MACHINE_SINGLE',
  MACHINE_LIST: 'MACHINE_LIST',
  DEPARTMENT_SINGLE: 'DEPARTMENT_SINGLE',

  // -------------MANAGER DASHBOARD -------------------//
  MANAGERDASHBOARDRECENT: 'MANAGERDASHBOARDRECENT',
  MANAGERONGOINTASK: 'MANAGERONGOINGTASK',
  MANAGERAPPROVETASK: 'MANAGERAPPROVETASK',
  MANAGERSCHEDULEDTASK: 'MANAGERSCHEDULEDTASK'

}

export { dashboard }
